import React from 'react'

interface ComponentTitleProps {
  title?: string
  description?: string
}

export function ComponentTitle({ title, description }: ComponentTitleProps) {
  if (!title) return null

  return (
    <div className="flex flex-col gap-y-1">
      <h2 className="text-xl font-semibold">{title}</h2>
      {description && <p className="text-sm text-muted-foreground">{description}</p>}
    </div>
  )
}
